import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import List from '../components/Board/List';

import globalStyles from '../assets/styles/styles.module.scss'; // ⚠️ vérifier le nombre de "../"

const makeMapStateToProps = () => {
  const selectListById = selectors.makeSelectListById();
  const selectCardIdsByListId = selectors.makeSelectCardIdsByListId();
  const selectCardNamesByIds = selectors.makeSelectCardNamesByIds(); // ─── 5c ───

  return (state, { id }) => {
    const { name, color, isPersisted } = selectListById(state, id);
    const cardIds = selectCardIdsByListId(state, id);

    const isCurrentUserOwner = selectors.selectIsOwnerBoard(state);
    const isCurrentUserEditor = selectors.selectCanEditBoard(state);
    console.log('On peut CanEDIT');
    console.log(isCurrentUserOwner);

    // ─── 5c : groupement de CETTE liste ───
    const layout = selectors.selectHierarchyLayoutForCurrentBoard(state);
    const listGroups = (layout && layout.groups && layout.groups[id]) || {
      parentGroups: {},
      orphanCardIds: cardIds,
    };
    // ─── 5c : noms des parents (pour l'en-tête des encadrés) ───
    const parentIds = Object.keys(listGroups.parentGroups);
    const parentNames = selectCardNamesByIds(state, parentIds);
    // Couleur de fond de liste (réutilise la convention du ColorPicker)
    const listColorClass = (colorname) =>
      colorname ? globalStyles[`background${upperFirst(camelCase(colorname))}`] : null;

    return {
      name,
      color,
      isPersisted,
      cardIds,
      canEdit: isCurrentUserEditor,
      isOwner: isCurrentUserOwner,
      listGroups, // ─── 5c ───
      parentNames, // ─── 5c ───
      listColorClass,
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => entryActions.updateList(id, data),
      onSort: (data) => entryActions.sortList(id, data),
      onDelete: () => entryActions.deleteList(id),
      onCardCreate: (data, autoOpen) => entryActions.createCard(id, data, autoOpen),
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(List);
